import { UseFormReturn } from "react-hook-form";
import { SelfDeclarationFormData } from "@/model/schemas";
import React from "react";
import { Pencil } from "lucide-react";

const inputClass = (hasError: boolean) =>
  `w-full h-11 rounded-lg border bg-white px-4 pr-10 text-sm outline-none transition-colors focus:border-[#0FD131] focus:ring-2 focus:ring-[#9BFBE0] ${hasError ? "border-red-400" : "border-gray-300"}`;

const SelfDeclaration = ({ form }: { form: UseFormReturn<SelfDeclarationFormData> }) => {
  const { register, formState } = form;

  return (
    <div className="space-y-5">
      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Full name</h6>
        <input
          type="text"
          {...register("declarantName")}
          className={inputClass(!!formState.errors.declarantName)}
          placeholder="Enter your full name"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.declarantName && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.declarantName.message}</p>
        )}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Address</h6>
        <input
          type="text"
          {...register("declarantAddress")}
          className={inputClass(!!formState.errors.declarantAddress)}
          placeholder="Enter your address"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.declarantAddress && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.declarantAddress.message}</p>
        )}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Declared income</h6>
        <input
          type="number"
          {...register("declaredIncome", { valueAsNumber: true })}
          className={inputClass(!!formState.errors.declaredIncome)}
          placeholder="0"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.declaredIncome && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.declaredIncome.message}</p>
        )}
      </div>

      <div className="flex items-start gap-3">
        <input
          type="checkbox"
          {...register("canMeetCommitment")}
          className="mt-1 size-5 rounded border-gray-300 text-[#0FD131] focus:ring-[#9BFBE0]"
          id="canMeetCommitment"
        />
        <label htmlFor="canMeetCommitment" className="text-sm text-gray-700">
          I declare that the information provided is true and correct, and I confirm that I can meet the financial
          commitment.
        </label>
      </div>
      {formState.errors.canMeetCommitment && (
        <p className="text-sm text-red-500">{formState.errors.canMeetCommitment.message}</p>
      )}
    </div>
  );
};

export default SelfDeclaration;
